import { RadioState } from '@remote-com/mushu/src/components/Ui/Form/Radio/Radio.styled';
import { Button } from 'remote-com-shared/components/Button';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { staticAssetUrl } from 'remote-com-shared/domains/assets/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';
import { Label, Title, Description } from '@/src/views/G2LeaderPage/RankSlice';
import { SectionHeaderTitle, SectionGrid } from '@/src/views/GetStarted/Testimonials';
import { FormWrapper, RadioButtonContent } from '@/src/views/RemoteRelocation';

const backgroundSeconaryURL = '/images/landing/contact-us-background-purple.svg';

export const SectionWrapper = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '100px', '150px')}
  position: relative;
  text-align: center;
  background-color: var(--colors-darkBlue);
  color: var(--colors-blank);

  && {
    ${Title}, ${Label}, ${Description} {
      color: var(--colors-blank);
      display: flex;
      justify-content: center;
      margin: auto;
    }

    ${Title} {
      font-family: var(--typography-fontBossa);
    }
  }

  ${ContentContainer} {
    z-index: 1;
    position: relative;
  }
`;
export const PriceCard = styled.div`
  display: flex;
  flex-wrap: wrap;

  & + & {
    ${fluidProp(['padding-top'], '80px', '120px')}
  }
`;

export const CardHeader = styled.div`
  width: 50%;

  ${RadioButtonContent} {
    display: flex;
    flex-direction: column;
    margin-left: 12px;
    opacity: 1;

    span {
      margin-top: 2px;
      font-size: 13px;
    }
  }

  ${RadioState} {
    border-color: ${({ theme }) => theme.colors.moonRaker_45};
  }

  ${FormWrapper} {
    gap: 40px;
  }

  ${tabletBreakpoint(css`
    width: 90%;
  `)}
`;

export const CardContent = styled.div`
  width: 50%;
  ${fluidProp(['margin-bottom'], '20px', '40px')}

  ${tabletBreakpoint(css`
    width: 90%;
    margin-top: 30px;
  `)}
`;

export const CardDescription = styled.div`
  color: var(--colors-selago);
  text-align: left;
  margin-bottom: 19px;

  ul {
    li {
      list-style-image: url(/images/check-turquoise.svg);
      margin-bottom: 19px;
      color: var(--colors-selago);
    }
  }
`;

export const CardTitle = styled.div`
  ${({ theme }) => theme.typography.bodySMMedium}
  text-transform: uppercase;
  margin-bottom: 23px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const CardPrice = styled.div`
  ${({ theme }) => theme.typography.scale2}
  ${fluidProp('font-size', '54px', '70px')}
  margin-bottom: 5px;

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const CardNote = styled.div`
  margin-bottom: 33px;
`;

export const CardsSection = styled.div`
  margin-top: 50px;
`;

export const CardCtaLink = styled(Button)`
  && {
    font-family: var(--typography-fontBrand);
    margin: auto;

    ${({ $tone }) => {
      switch ($tone) {
        case 'light':
          return css`
            color: var(--colors-darkBlue);
            background-color: #dfefd3;
          `;
        default:
          return css`
            background-color: #5700ff;
          `;
      }
    }}
  }
`;

export const CardStartsAt = styled.div`
  color: var(--colors-spindle);
  ${({ theme }) => theme.typography.bodySpecial}
  margin-bottom: 17px;
`;

export const IllustrationWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 0;

  ${tabletBreakpoint(css`
    display: none;
  `)};
`;

export const PrimaryCtaSectionWrapper = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '90px', '140px')}
  font-family: var(--typography-fontBrand);
  position: relative;
  text-align: center;
  background-image: url(${staticAssetUrl(backgroundSeconaryURL)});
  background-color: var(--colors-darkBlue);
  background-size: cover;
  background-position: center;
`;

export const PrimaryCtaTitle = styled.h1`
  ${({ theme }) => theme.typography.scale3}
  ${fluidProp(['font-size'], '24px', '42px')}
  color: var(--colors-blank);
  margin: 0 auto;
`;

export const PrimaryCtaContainer = styled(ContentContainer)`
  position: relative;
  z-index: 1;
`;

export const RewardsSectionHeader = styled.div`
  margin-top: 200px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const RewardsTitle = styled.div`
  ${({ theme }) => theme.typography.scale4}
`;
export const RewardsDescription = styled.div`
  ${({ theme }) => theme.typography.body}
  color: var(--colors-selago);
  max-width: 500px;
`;
export const CardsWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 45px;
  padding-bottom: 100px;
`;
export const CardBlock = styled.div`
  width: 260px;
  min-height: 346px;
  background: var(--colors-blank);
  box-shadow: 1px 8px 45px rgba(0, 35, 75, 0.09);
  border-radius: 24px;
  padding: 40px 30px;
  box-sizing: border-box;
  text-align: center;
  margin-top: 85px;
`;
export const RewardsCardTitle = styled.div`
  color: var(--colors-darkBlue);
  ${({ theme }) => theme.typography.titleSM}
  padding-bottom: 6px;

  > * {
    font-size: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;
export const RewardsCardDescription = styled.div`
  ${({ theme }) => theme.typography.body}
  color: #778CA3;

  > * {
    font-size: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 8px;
  padding-bottom: 33px;
`;

export const TableLeftBgWrapper = styled.div`
  width: 84%;
  height: 60%;
  background-color: #f8f5ff;
  position: absolute;
  left: -30%;
  bottom: -15%;
  border-top-right-radius: 100%;
  z-index: -1;

  ${tabletBreakpoint(css`
    display: none;
  `)}
`;

export const TableRightBgWrapper = styled(TableLeftBgWrapper)`
  left: unset;
  right: -30%;
  border-top-right-radius: 0;
  border-top-left-radius: 100%;
`;

export const TestimonialsSection = styled.section`
  color: var(--colors-blank);
  background: #5700ff;
  display: flex;
  ${fluidProp('padding-top', '80px', '114px')}
  position: relative;

  ${SectionGrid} {
    margin-top: 124px;
  }

  ${SectionHeaderTitle} {
    font-family: var(--typography-fontBossa);
  }
`;

export const TestimonialsIllustrationWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 0;

  ${tabletBreakpoint(css`
    display: none;
  `)};
`;
